export const QuestionTypes = [
  { id: 'SINGLE', name: 'SINGLE' },
  { id: 'MULTI', name: 'MULTI' },
  { id: 'MATCHING', name: 'MATCHING' },
  { id: 'PRONUNCIATION', name: 'PRONUNCIATION' },
  { id: 'WRITE', name: 'WRITE' },
  { id: 'BOOLEAN', name: 'TRUE AND FALSE' },
];
